import { GOOGLE_PLACES_LIBRARY, GOOGLE_PLACES_SCRIPT_ID } from "./constants";

let googlePlacesLoaderPromise: Promise<void> | null = null;

export const ensureGooglePlacesLoaded = async (): Promise<void> => {
  if (window.google?.maps?.places) {
    return;
  }

  if (googlePlacesLoaderPromise) {
    await googlePlacesLoaderPromise;
    return;
  }

  googlePlacesLoaderPromise = new Promise((resolve, reject) => {
    const apiKey = window.AppConfig?.GOOGLE_API_KEY;

    if (!apiKey) {
      reject(new Error("GOOGLE_API_KEY is not configured"));
      return;
    }

    const existingScript = document.getElementById(
      GOOGLE_PLACES_SCRIPT_ID
    ) as HTMLScriptElement | null;

    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(), { once: true });

      existingScript.addEventListener(
        "error",
        () => reject(new Error("Failed to load Google Places API")),
        { once: true }
      );

      return;
    }

    const script = document.createElement("script");
    const scriptSource = new URL("https://maps.googleapis.com/maps/api/js");

    scriptSource.searchParams.set("key", apiKey);
    scriptSource.searchParams.set("libraries", GOOGLE_PLACES_LIBRARY);

    script.id = GOOGLE_PLACES_SCRIPT_ID;
    script.src = scriptSource.toString();
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Failed to load Google Places API"));

    document.head.appendChild(script);
  });

  await googlePlacesLoaderPromise;
};
